module.exports = __webpack_public_path__ + "img/文字_C级赛事@3x.5ded1e72.png";